document.addEventListener('DOMContentLoaded', function () {
  const builder = document.getElementById('cs-custom-color-selector');
  if (!builder) return;

  const CUSTOM_COLOR_PRICE = 45.0;
  const GRADIENT_COLOR_PRICE = 65.0;

  const COLORS = {
    'Bright Yellow': '#fffd1e',
    'Golden Yellow': '#ffbb26',
    'Vintage Gold': '#c39143',
    'Neon Yellow': '#edff00',
    'Ferrari Red': '#e4002b',
    'Blood Red': '#ec0037',
    'Burgundy': '#47222c',
    'Peach': '#ffbe98',
    'Coral': '#ff664b',
    'Bright Orange': '#fe5000',
    'Old Orange': '#dc4405',
    'Baby Pink': '#ffeaf1',
    'Light Pink': '#feb9dd',
    'Bright Pink': '#fb48c4',
    'Hot Pink': '#ea27c2',
    'Plum': '#72246C',
    'Fuchsia': '#9e007e',
    'Eggshell': '#f8f7f0',
    'Ivory': '#f6f0d2',
    'Beige': '#E4D7C5',
    'Bone': '#c6ac87',
    'Tan': '#A45A2A',
    'Chocolate Brown': '#4e3629',
    'Jade': '#6eceb2',
    'Mint': '#91D6AC',
    'Lime Green': '#97D700',
    'Chartreuse': '#e3f400',
    'Emerald': '#00965e',
    'Kelly Green': '#00b140',
    'Forest Green': '#115740',
    'Teal': '#007377',
    'Turquoise': '#00b5ec',
    'Aqua': '#aadded',
    'Light Blue': '#bed5f1',
    'Royal Blue': '#0064cc',
    'Navy': '#002851',
    'Lilac': '#8b84d7',
    'Violet': '#5c068c',
    'Amethyst': '#4343a0',
    'Dark Purple': '#4d2a68',
    'White': '#ffffff',
    'Silver': '#dde2e3',
    'Gunmetal': '#323c3f',
    'Black': '#040403',
    'Lavender': '#DFC5FE',
    'Rose Pink': '#F7879A',
    'Tiffany Blue': '#0abab5'
  };

  const COLOR_IMAGES = {
    'Vintage Gold': 'https://cdn.shopify.com/s/files/1/1708/1739/files/vintage_gold.png?v=1742157769',
    'Chocolate Brown': 'https://cdn.shopify.com/s/files/1/1708/1739/files/choc_brown.png?v=1742158912',
    'Blood Red': 'https://cdn.shopify.com/s/files/1/1708/1739/files/blood_red.png?v=1742158937',
    'Burgundy': 'https://cdn.shopify.com/s/files/1/1708/1739/files/burgundy.heic?v=1742158973',
    'Hot Pink': 'https://cdn.shopify.com/s/files/1/1708/1739/files/hot_pink.heic?v=1742159018',
    'Ferrari Red': 'https://cdn.shopify.com/s/files/1/1708/1739/files/ferrari_red.heic?v=1742159075',
    'Golden Yellow': 'https://cdn.shopify.com/s/files/1/1708/1739/files/golden_yellow.heic?v=1742159123',
    'Amethyst': 'https://cdn.shopify.com/s/files/1/1708/1739/files/amethyst.heic?v=1743032667',
    'Light Blue': 'https://cdn.shopify.com/s/files/1/1708/1739/files/light_blue.heic?v=1742159400',
    'Jade': 'https://cdn.shopify.com/s/files/1/1708/1739/files/jade.heic?v=1742159438',
    'Plum': 'https://cdn.shopify.com/s/files/1/1708/1739/files/plum.heic?v=1742159509',
    'Bright Orange': 'https://cdn.shopify.com/s/files/1/1708/1739/files/bright_orange.heic?v=1742159540',
    'Silver': 'https://cdn.shopify.com/s/files/1/1708/1739/files/silver.heic?v=1742159584',
    'Tan': 'https://cdn.shopify.com/s/files/1/1708/1739/files/tan.heic?v=1742159661',
    'Peach': 'https://cdn.shopify.com/s/files/1/1708/1739/files/peach.heic?v=1742159607',
    'Navy': 'https://cdn.shopify.com/s/files/1/1708/1739/files/navy.heic?v=1742159692',
    'Turquoise': 'https://cdn.shopify.com/s/files/1/1708/1739/files/turquoise.heic?v=1742159760',
    'Dark Purple': 'https://cdn.shopify.com/s/files/1/1708/1739/files/dark_purple.heic?v=1742159962',
    'Beige': 'https://cdn.shopify.com/s/files/1/1708/1739/files/beige.heic?v=1742160031',
    'Forest Green': 'https://cdn.shopify.com/s/files/1/1708/1739/files/forest_green.heic?v=1742160058',
    'Fuchsia': 'https://cdn.shopify.com/s/files/1/1708/1739/files/fuscia.heic?v=1742160102',
    'Eggshell': 'https://cdn.shopify.com/s/files/1/1708/1739/files/eggshell.heic?v=1742160141',
    'Tiffany Blue': 'https://cdn.shopify.com/s/files/1/1708/1739/files/tiffany.heic?v=1742160214',
    'Lavender': 'https://cdn.shopify.com/s/files/1/1708/1739/files/lavender.heic?v=1742160248',
    'Aqua': 'https://cdn.shopify.com/s/files/1/1708/1739/files/aqua.heic?v=1742160287',
    'Baby Pink': 'https://cdn.shopify.com/s/files/1/1708/1739/files/baby_pink.heic?v=1742160323',
    'Bone': 'https://cdn.shopify.com/s/files/1/1708/1739/files/bone.heic?v=1742160362',
    'Teal': 'https://cdn.shopify.com/s/files/1/1708/1739/files/teal.heic?v=1742160389',
    'Chartreuse': 'https://cdn.shopify.com/s/files/1/1708/1739/files/charteuse.heic?v=1742160429',
    'Kelly Green': 'https://cdn.shopify.com/s/files/1/1708/1739/files/kelly_green.heic?v=1742160467',
    'Old Orange': 'https://cdn.shopify.com/s/files/1/1708/1739/files/old_orange.heic?v=1742160499',
    'Bright Yellow': 'https://cdn.shopify.com/s/files/1/1708/1739/files/bright_yellow.heic?v=1742160529',
    'Mint': 'https://cdn.shopify.com/s/files/1/1708/1739/files/mint.heic?v=1742160576',
    'Emerald': 'https://cdn.shopify.com/s/files/1/1708/1739/files/emerald_green.heic?v=1742160612',
    'Coral': 'https://cdn.shopify.com/s/files/1/1708/1739/files/coral.heic?v=1742160646',
    'Light Pink': 'https://cdn.shopify.com/s/files/1/1708/1739/files/light_pink.heic?v=1742160676',
    'Black': 'https://cdn.shopify.com/s/files/1/1708/1739/files/black.heic?v=1742160704',
    'Royal Blue': 'https://cdn.shopify.com/s/files/1/1708/1739/files/royal_blue.heic?v=1742160734',
    'Neon Yellow': 'https://cdn.shopify.com/s/files/1/1708/1739/files/neon_yellow.heic?v=1742160794',
    'Bright Pink': 'https://cdn.shopify.com/s/files/1/1708/1739/files/bright_pink.heic?v=1742160829',
    'Lilac': 'https://cdn.shopify.com/s/files/1/1708/1739/files/lilac.heic?v=1742161167',
    'White': 'https://cdn.shopify.com/s/files/1/1708/1739/files/bleach_white.heic?v=1742161234',
    'Lime Green': 'https://cdn.shopify.com/s/files/1/1708/1739/files/lime_green.heic?v=1742161279',
    'Rose Pink': 'https://cdn.shopify.com/s/files/1/1708/1739/files/rose_pink.heic?v=1742161317',
    'Violet': 'https://cdn.shopify.com/s/files/1/1708/1739/files/violet.heic?v=1742161348',
    'Ivory': 'https://cdn.shopify.com/s/files/1/1708/1739/files/ivory.jpg?v=1742161371',
    'Gunmetal': 'https://cdn.shopify.com/s/files/1/1708/1739/files/gun_metal.jpg?v=1742161393'
  };

  const DEFAULT_PLACEHOLDER = {
    name: 'Black',
    code: '#040403',
    image: COLOR_IMAGES['Black'] || '',
    isCustom: false,
    isGradient: false
  };

  const DEFAULT_GRADIENT_END = COLORS['Emerald'] || '#00965e';

  const segments = Array.from(builder.querySelectorAll('.ff-builder__segment'));
  const tabs = Array.from(builder.querySelectorAll('.ff-builder__tab'));
  const editingText = builder.querySelector('#ffBuilderEditing');
  const colorInput = builder.querySelector('#ffBuilderColorInput');
  const gradientStartInput = builder.querySelector('#ffBuilderGradientStart');
  const gradientEndInput = builder.querySelector('#ffBuilderGradientEnd');
  const swatchesWrap = builder.querySelector('#cs-standard-swatches');
  const swatchViewport = builder.querySelector('#ffSwatchViewport');
  const swatchToggle = builder.querySelector('#ffSwatchToggle');

  const selectionMode = builder.getAttribute('data-selection-mode') || 'double';
  const hasGradientMode = builder.getAttribute('data-has-gradient') === 'true';

  const inputs = {
    primary: document.getElementById('cs-primary-feather-input'),
    top: document.getElementById('cs-top-feather-input'),
    middle: document.getElementById('cs-middle-feather-input'),
    bottom: document.getElementById('cs-bottom-feather-input'),
    priceAdjustment: document.getElementById('cs-price-adjustment-input'),
    selectionMode: document.getElementById('cs-selection-mode-input')
  };

  const labels = {
    primary: builder.getAttribute('data-label-primary') || 'Primary Color',
    top: builder.getAttribute('data-label-top') || 'Top Feather',
    middle: builder.getAttribute('data-label-middle') || 'Middle Feather',
    bottom: builder.getAttribute('data-label-bottom') || 'Bottom Feather'
  };

  if (!window.colorState) {
    window.colorState = {
      currentSelection: selectionMode === 'four' ? 'primary' : 'top',
      primaryColor: null,
      topColor: null,
      middleColor: null,
      bottomColor: null,
      customColorCount: 0,
      gradientColorCount: 0,
      lastEditedSelection: selectionMode === 'four' ? 'primary' : 'top',
      hasAttemptedAddToCart: false,
      selectionMode: selectionMode,
      hasFourColorMode: selectionMode === 'four',
      positionLabels: labels
    };
  } else {
    window.colorState.selectionMode = selectionMode;
    window.colorState.hasFourColorMode = selectionMode === 'four';
    window.colorState.positionLabels = labels;
    if (!window.colorState.currentSelection) {
      window.colorState.currentSelection = selectionMode === 'four' ? 'primary' : 'top';
    }
    if (typeof window.colorState.gradientColorCount === 'undefined') {
      window.colorState.gradientColorCount = 0;
    }
  }

  let mode = 'standard';
  let swatches = [];
  let isSwatchExpanded = false;
  let collapsedSwatchHeight = 0;
  const DEFAULT_VISIBLE_ROWS = 3;

  function buildDefaultStandardColor() {
    return {
      name: 'Black',
      code: '#040403',
      image: COLOR_IMAGES['Black'] || '',
      isCustom: false,
      isGradient: false
    };
  }

  function getPositionOrder() {
    const order = [];
    if (selectionMode === 'four') order.push('primary');
    order.push('top');
    if (selectionMode === 'triple' || selectionMode === 'four') order.push('middle');
    if (selectionMode !== 'single') order.push('bottom');
    return order;
  }

  function updatePriceAdjustment() {
    let customCount = 0;
    let gradientCount = 0;

    getPositionOrder().forEach((position) => {
      const value = window.colorState[`${position}Color`];
      if (!value) return;

      if (value.isGradient) {
        gradientCount += 1;
      } else if (value.isCustom) {
        customCount += 1;
      }
    });

    window.colorState.customColorCount = customCount;
    window.colorState.gradientColorCount = gradientCount;

    const adjustment = (customCount * CUSTOM_COLOR_PRICE) + (gradientCount * GRADIENT_COLOR_PRICE);

    if (inputs.priceAdjustment) {
      inputs.priceAdjustment.value = adjustment > 0 ? adjustment.toFixed(2) : '';
    }

    if (inputs.selectionMode) {
      inputs.selectionMode.value = selectionMode;
    }
  }

  function getSegmentByPosition(position) {
    return builder.querySelector(`.ff-builder__segment[data-position="${position}"]`);
  }

  function getStateColor(position) {
    return window.colorState[`${position}Color`] || null;
  }

  function setStateColor(position, colorObject) {
    window.colorState[`${position}Color`] = colorObject;
  }

  function updateInput(position, colorObject) {
    const input = inputs[position];
    if (!input || !colorObject) return;

    if (colorObject.isGradient) {
      input.value = `Gradient - ${colorObject.startCode} to ${colorObject.endCode}`;
    } else if (colorObject.isCustom) {
      input.value = `Custom - ${colorObject.code}`;
    } else {
      input.value = colorObject.name;
    }
  }

  function setSegmentEmpty(segment) {
    if (!segment) return;

    segment.dataset.type = 'empty';
    segment.dataset.name = DEFAULT_PLACEHOLDER.name;
    segment.dataset.hex = DEFAULT_PLACEHOLDER.code;
    segment.dataset.image = DEFAULT_PLACEHOLDER.image || '';

    segment.classList.remove('is-custom', 'is-gradient');
    segment.classList.add('is-empty', 'is-standard');

    segment.style.background = '';
    segment.style.backgroundColor = '';
    segment.style.backgroundImage = DEFAULT_PLACEHOLDER.image ? `url('${DEFAULT_PLACEHOLDER.image}')` : 'none';
    segment.style.backgroundSize = 'cover';
    segment.style.backgroundPosition = 'center';
    segment.style.backgroundRepeat = 'no-repeat';

    const nameEl = segment.querySelector('.ff-builder__name');
    const hexEl = segment.querySelector('.ff-builder__hex');
    if (nameEl) nameEl.textContent = DEFAULT_PLACEHOLDER.name;
    if (hexEl) hexEl.textContent = DEFAULT_PLACEHOLDER.code;
  }

  function applyStandardToSegment(segment, colorObject) {
    if (!segment) return;

    segment.dataset.type = 'standard';
    segment.dataset.name = colorObject.name;
    segment.dataset.hex = colorObject.code;
    segment.dataset.image = colorObject.image || '';

    segment.classList.remove('is-custom', 'is-empty', 'is-gradient');
    segment.classList.add('is-standard');

    segment.style.background = '';
    segment.style.backgroundColor = '';
    segment.style.backgroundImage = colorObject.image ? `url('${colorObject.image}')` : 'none';
    segment.style.backgroundSize = 'cover';
    segment.style.backgroundPosition = 'center';
    segment.style.backgroundRepeat = 'no-repeat';

    const nameEl = segment.querySelector('.ff-builder__name');
    const hexEl = segment.querySelector('.ff-builder__hex');
    if (nameEl) nameEl.textContent = colorObject.name;
    if (hexEl) hexEl.textContent = colorObject.code;
  }

  function applyCustomToSegment(segment, colorObject) {
    if (!segment) return;

    segment.dataset.type = 'custom';
    segment.dataset.name = colorObject.name;
    segment.dataset.hex = colorObject.code;
    segment.dataset.image = '';

    segment.classList.remove('is-standard', 'is-empty', 'is-gradient');
    segment.classList.add('is-custom');

    segment.style.backgroundImage = 'none';
    segment.style.background = colorObject.code;
    segment.style.backgroundColor = colorObject.code;

    const nameEl = segment.querySelector('.ff-builder__name');
    const hexEl = segment.querySelector('.ff-builder__hex');
    if (nameEl) nameEl.textContent = 'Custom Color';
    if (hexEl) hexEl.textContent = colorObject.code;
  }

  function applyGradientToSegment(segment, colorObject) {
    if (!segment) return;

    const gradientValue = `linear-gradient(135deg, ${colorObject.startCode} 0%, ${colorObject.endCode} 100%)`;

    segment.dataset.type = 'gradient';
    segment.dataset.name = colorObject.name;
    segment.dataset.hex = `${colorObject.startCode} → ${colorObject.endCode}`;
    segment.dataset.image = '';

    segment.classList.remove('is-standard', 'is-empty', 'is-custom');
    segment.classList.add('is-gradient');

    segment.style.backgroundImage = 'none';
    segment.style.background = gradientValue;
    segment.style.backgroundColor = '';

    const nameEl = segment.querySelector('.ff-builder__name');
    const hexEl = segment.querySelector('.ff-builder__hex');
    if (nameEl) nameEl.textContent = 'Gradient';
    if (hexEl) hexEl.textContent = `${colorObject.startCode} → ${colorObject.endCode}`;
  }

  function renderSegmentFromState(position) {
    const segment = getSegmentByPosition(position);
    const colorObject = getStateColor(position);

    if (!segment) return;

    if (!colorObject) {
      setSegmentEmpty(segment);
      return;
    }

    if (colorObject.isGradient) {
      applyGradientToSegment(segment, colorObject);
    } else if (colorObject.isCustom) {
      applyCustomToSegment(segment, colorObject);
    } else {
      applyStandardToSegment(segment, colorObject);
    }
  }

  function getOrderedColorEntries() {
    const entries = Object.entries(COLORS);
    const blackEntry = entries.find(([name]) => name === 'Black');
    const rest = entries.filter(([name]) => name !== 'Black');
    return blackEntry ? [blackEntry, ...rest] : entries;
  }

  function buildSwatches() {
    if (!swatchesWrap) return;

    swatchesWrap.innerHTML = '';

    getOrderedColorEntries().forEach(([name, hex]) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'ff-builder__swatch';
      button.setAttribute('aria-label', name);
      button.dataset.name = name;
      button.dataset.hex = hex;
      button.dataset.image = COLOR_IMAGES[name] || '';
      button.style.backgroundColor = hex;

      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (mode !== 'standard') return;

        const activePosition = window.colorState.currentSelection;
        const colorObject = {
          name,
          code: hex,
          image: COLOR_IMAGES[name] || '',
          isCustom: false,
          isGradient: false
        };

        setStateColor(activePosition, colorObject);
        updateInput(activePosition, colorObject);
        renderSegmentFromState(activePosition);
        updatePriceAdjustment();
        syncControlsToActiveSegment();
        autoAdvance();
      });

      swatchesWrap.appendChild(button);
    });

    swatches = Array.from(swatchesWrap.querySelectorAll('.ff-builder__swatch'));
  }

  function measureCollapsedHeight() {
    if (!swatchesWrap || !swatches.length) return 0;

    const uniqueRows = [];
    swatches.forEach((swatch) => {
      const top = swatch.offsetTop;
      if (!uniqueRows.some((rowTop) => Math.abs(rowTop - top) < 2)) {
        uniqueRows.push(top);
      }
    });

    if (uniqueRows.length <= DEFAULT_VISIBLE_ROWS) {
      return swatchesWrap.scrollHeight;
    }

    const targetRowTop = uniqueRows[DEFAULT_VISIBLE_ROWS - 1];
    let maxBottom = 0;

    swatches.forEach((swatch) => {
      if (Math.abs(swatch.offsetTop - targetRowTop) < 2) {
        const bottom = swatch.offsetTop + swatch.offsetHeight;
        if (bottom > maxBottom) maxBottom = bottom;
      }
    });

    return maxBottom;
  }

  function applySwatchViewportState() {
    if (!swatchViewport || !swatchesWrap || !swatchToggle) return;

    const totalHeight = swatchesWrap.scrollHeight;
    collapsedSwatchHeight = measureCollapsedHeight();
    const hasOverflow = totalHeight > collapsedSwatchHeight + 4;

    swatchViewport.classList.toggle('has-overflow', hasOverflow);
    swatchToggle.hidden = !hasOverflow;

    if (!hasOverflow) {
      swatchViewport.classList.remove('is-collapsed', 'is-expanded');
      swatchViewport.style.maxHeight = 'none';
      swatchToggle.setAttribute('aria-expanded', 'true');
      swatchToggle.textContent = 'View Less';
      return;
    }

    if (isSwatchExpanded) {
      swatchViewport.classList.remove('is-collapsed');
      swatchViewport.classList.add('is-expanded');
      swatchViewport.style.maxHeight = `${totalHeight}px`;
      swatchToggle.setAttribute('aria-expanded', 'true');
      swatchToggle.textContent = 'View Less';
    } else {
      swatchViewport.classList.remove('is-expanded');
      swatchViewport.classList.add('is-collapsed');
      swatchViewport.style.maxHeight = `${collapsedSwatchHeight}px`;
      swatchToggle.setAttribute('aria-expanded', 'false');
      swatchToggle.textContent = 'View More';
    }
  }

  function bindSwatchToggle() {
    if (!swatchToggle) return;

    swatchToggle.addEventListener('click', function () {
      isSwatchExpanded = !isSwatchExpanded;
      applySwatchViewportState();
    });
  }

  function getSegmentLabel(segment) {
    return segment?.dataset.label || 'Section';
  }

  function updateEditingText() {
    const segment = getSegmentByPosition(window.colorState.currentSelection);
    if (!segment || !editingText) return;
    editingText.textContent = `EDITING: ${getSegmentLabel(segment).toUpperCase()}`;
  }

  function setActiveSegment(position) {
    window.colorState.currentSelection = position;
    window.colorState.lastEditedSelection = position;

    segments.forEach((segment) => {
      segment.classList.toggle('is-active', segment.dataset.position === position);
    });

    updateEditingText();
    syncControlsToActiveSegment();
  }

  function syncSwatches() {
    swatches.forEach((swatch) => swatch.classList.remove('is-active'));

    const activePosition = window.colorState.currentSelection;
    const colorObject = getStateColor(activePosition);

    if (!colorObject || colorObject.isCustom || colorObject.isGradient) return;

    const match = swatches.find(
      (swatch) => (swatch.dataset.hex || '').toLowerCase() === colorObject.code.toLowerCase()
    );

    if (match) match.classList.add('is-active');
  }

  function syncControlsToActiveSegment() {
    updateEditingText();

    const activePosition = window.colorState.currentSelection;
    const colorObject = getStateColor(activePosition);

    if (mode === 'custom') {
      if (colorObject && colorObject.isCustom) {
        colorInput.value = colorObject.code;
      } else if (colorObject && !colorObject.isGradient) {
        colorInput.value = colorObject.code;
      } else {
        colorInput.value = DEFAULT_PLACEHOLDER.code;
      }
    } else if (mode === 'gradient' && hasGradientMode) {
      if (colorObject && colorObject.isGradient) {
        gradientStartInput.value = colorObject.startCode;
        gradientEndInput.value = colorObject.endCode;
      } else if (colorObject && !colorObject.isCustom) {
        gradientStartInput.value = colorObject.code;
        gradientEndInput.value = DEFAULT_GRADIENT_END;
      } else {
        gradientStartInput.value = DEFAULT_PLACEHOLDER.code;
        gradientEndInput.value = DEFAULT_GRADIENT_END;
      }
    } else {
      syncSwatches();
    }
  }

  function setTabMode(newMode) {
    if (newMode === 'gradient' && !hasGradientMode) return;

    mode = newMode;

    tabs.forEach((tab) => {
      tab.classList.toggle('is-active', tab.dataset.mode === newMode);
    });

    builder.classList.toggle('is-custom-mode', newMode === 'custom');
    builder.classList.toggle('is-gradient-mode', newMode === 'gradient');

    const activePosition = window.colorState.currentSelection;
    const colorObject = getStateColor(activePosition);

    if (newMode === 'gradient' && (!colorObject || !colorObject.isGradient)) {
      const startCode =
        colorObject && !colorObject.isCustom && !colorObject.isGradient
          ? colorObject.code
          : DEFAULT_PLACEHOLDER.code;

      if (gradientStartInput) gradientStartInput.value = startCode;
      if (gradientEndInput) gradientEndInput.value = DEFAULT_GRADIENT_END;
    }

    if (newMode === 'custom' && colorInput) {
      if (colorObject && colorObject.isCustom) {
        colorInput.value = colorObject.code;
      } else if (colorObject && !colorObject.isGradient) {
        colorInput.value = colorObject.code;
      } else {
        colorInput.value = DEFAULT_PLACEHOLDER.code;
      }
    }

    syncControlsToActiveSegment();

    if (newMode === 'standard') {
      requestAnimationFrame(applySwatchViewportState);
    }
  }

  function autoAdvance() {
    const order = getPositionOrder();
    const currentIndex = order.indexOf(window.colorState.currentSelection);

    for (let i = currentIndex + 1; i < order.length; i += 1) {
      const nextPosition = order[i];
      if (!getStateColor(nextPosition)) {
        setActiveSegment(nextPosition);
        return;
      }
    }

    setActiveSegment(window.colorState.currentSelection);
  }

  function applyColorToCurrent(name, code, isCustom) {
    const position = window.colorState.currentSelection;
    const colorObject = {
      name: isCustom ? 'Custom Color' : name,
      code,
      image: isCustom ? '' : (COLOR_IMAGES[name] || ''),
      isCustom,
      isGradient: false
    };

    setStateColor(position, colorObject);
    updateInput(position, colorObject);
    renderSegmentFromState(position);
    updatePriceAdjustment();
    syncControlsToActiveSegment();
    autoAdvance();
  }

  function applyGradientToCurrent(startCode, endCode) {
    const position = window.colorState.currentSelection;
    const colorObject = {
      name: 'Gradient',
      code: '',
      image: '',
      isCustom: false,
      isGradient: true,
      startCode: startCode,
      endCode: endCode
    };

    setStateColor(position, colorObject);
    updateInput(position, colorObject);
    renderSegmentFromState(position);
    updatePriceAdjustment();
    syncControlsToActiveSegment();
  }

  window.updateColorSelection = function (colorName, colorCode, isCustom) {
    applyColorToCurrent(colorName, colorCode, isCustom);
  };

  segments.forEach((segment) => {
    segment.addEventListener('click', function () {
      setActiveSegment(segment.dataset.position);
    });
  });

  tabs.forEach((tab) => {
    tab.addEventListener('click', function () {
      setTabMode(tab.dataset.mode || 'standard');
    });
  });

  if (colorInput) {
    colorInput.addEventListener('input', function (e) {
      if (mode !== 'custom') return;
      applyColorToCurrent('Custom Color', e.target.value, true);
    });
  }

  if (gradientStartInput) {
    gradientStartInput.addEventListener('input', function () {
      if (mode !== 'gradient') return;
      const start = gradientStartInput.value || DEFAULT_PLACEHOLDER.code;
      const end = gradientEndInput ? (gradientEndInput.value || DEFAULT_GRADIENT_END) : DEFAULT_GRADIENT_END;
      applyGradientToCurrent(start, end);
    });
  }

  if (gradientEndInput) {
    gradientEndInput.addEventListener('input', function () {
      if (mode !== 'gradient') return;
      const start = gradientStartInput ? (gradientStartInput.value || DEFAULT_PLACEHOLDER.code) : DEFAULT_PLACEHOLDER.code;
      const end = gradientEndInput.value || DEFAULT_GRADIENT_END;
      applyGradientToCurrent(start, end);
    });
  }

  buildSwatches();
  bindSwatchToggle();

  ['primary', 'top', 'middle', 'bottom'].forEach((position) => {
    const segment = getSegmentByPosition(position);
    if (segment) setSegmentEmpty(segment);
  });

  const firstPosition = selectionMode === 'four' ? 'primary' : 'top';
  const defaultStandardColor = buildDefaultStandardColor();

  setStateColor(firstPosition, defaultStandardColor);
  updateInput(firstPosition, defaultStandardColor);
  renderSegmentFromState(firstPosition);

  if (selectionMode === 'four') {
    setActiveSegment('primary');
  } else {
    setActiveSegment('top');
  }

  updatePriceAdjustment();
  syncControlsToActiveSegment();
  setTabMode('standard');

  requestAnimationFrame(function () {
    applySwatchViewportState();
  });

  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      applySwatchViewportState();
    }, 120);
  });
});